import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import {
  APP_INITIALIZER,
  EnvironmentProviders,
  importProvidersFrom,
  Provider,
} from '@angular/core';
import { authAppInitializerFactory } from '@sprint-expert/app/core/auth/auth-app-initializer.factory';
import { AuthGuard } from '@sprint-expert/app/core/auth/auth-guard.service';
import { AuthInterceptor } from '@sprint-expert/app/core/auth/auth-interceptor';
import { authModuleConfig } from '@sprint-expert/app/core/auth/auth-module-config';
import { AuthService } from '@sprint-expert/app/core/auth/auth.service';
import {
  OAuthModule,
  OAuthModuleConfig,
  OAuthStorage,
} from 'angular-oauth2-oidc';

export function storageFactory(): OAuthStorage {
  return localStorage;
}

export const provideAuth = (): Array<Provider | EnvironmentProviders> => {
  return [
    importProvidersFrom(HttpClientModule, OAuthModule.forRoot()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: AuthGuard,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: authAppInitializerFactory,
      deps: [AuthService],
      multi: true,
    },
    { provide: OAuthModuleConfig, useValue: authModuleConfig },
    {
      provide: OAuthStorage,
      useFactory: storageFactory,
    },
  ];
};
